import { faker } from '@faker-js/faker';
import { define } from 'cooky-cutter';
import { Role, UserRoleType } from '../types';

export const rolesFactory = define<Role>({
  id: () => faker.string.uuid(),
  name: () => faker.helpers.arrayElement(Object.values(UserRoleType)),
});
